import React, { useState, useRef } from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  // We duplicate the testimonial to show carousel functionality as requested
  const testimonials = [{
    quote: "I came in for something I could do on my lunch break. I left looking like I'd been on a two-week vacation. My skin was glowing in a way it hasn't since I was 25.",
    author: 'Patient, San Ramon CA'
  }, {
    quote: "The hydration is unlike anything I've experienced with topical serums. My makeup goes on flawlessly now, but honestly, I barely need to wear any.",
    author: 'Sarah M., Danville CA'
  }, {
    quote: "It's subtle but profound. People keep asking if I've changed my diet or if I'm pregnant because of the 'glow'. It's just the mesotherapy.",
    author: 'Elena R., Walnut Creek CA'
  }];
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };
  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      // Swipe left
      setActiveIndex(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
    }
    if (touchStartX.current - touchEndX.current < -50) {
      // Swipe right
      setActiveIndex(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
    }
  };
  return <section className="py-24 md:py-32 bg-cream overflow-hidden" data-id="element-211">
      <div className="container mx-auto px-4 md:px-6" data-id="element-212">
        <FadeIn data-id="element-213">
          <div className="max-w-4xl mx-auto text-center relative" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-214">
            <div className="text-gold text-4xl md:text-6xl font-serif mb-8 opacity-50" data-id="element-215">
              "
            </div>

            <div className="relative h-[200px] md:h-[160px]" data-id="element-216">
              {testimonials.map((testimonial, index) => <div key={index} className={`absolute top-0 left-0 w-full transition-all duration-700 ease-in-out ${index === activeIndex ? 'opacity-100 translate-x-0' : index < activeIndex ? 'opacity-0 -translate-x-full' : 'opacity-0 translate-x-full'}`} data-id="element-217">
                  <p className="text-2xl md:text-4xl font-serif italic text-primary leading-relaxed mb-8" data-id="element-218">
                    {testimonial.quote}
                  </p>
                  <p className="text-sm md:text-base font-sans font-medium text-foreground/60 uppercase tracking-widest" data-id="element-219">
                    — {testimonial.author}
                  </p>
                </div>)}
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center gap-3 mt-12" data-id="element-220">
              {testimonials.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-gold w-8' : 'bg-divider hover:bg-gold/50'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-221" />)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}